/**
 * Shell-mounted notice when server consent sync fails (R8 / §8).
 * Sits in document flow under CustomerShellHeader — never overlays top chrome.
 */

import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { subscribeConsentSyncFailed } from '../features/consent/consentSyncNotice.js';
import {
  CUSTOMER_INLINE_NOTICE_WIDTH_CLASS,
  CUSTOMER_SHELL_WIDTH_CLASS,
  CUSTOMER_TOP_BAR_CLEARANCE_TOP_CLASS,
} from './customerTopBarStyles.js';

export function ConsentSyncFailedBanner(): JSX.Element | null {
  const { t } = useTranslation('customer');
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    return subscribeConsentSyncFailed(() => {
      setVisible(true);
    });
  }, []);

  if (!visible) {
    return null;
  }

  return (
    <div
      className={`customer-safe-area-x pointer-events-none sticky ${CUSTOMER_TOP_BAR_CLEARANCE_TOP_CLASS} z-[5] px-3 pt-2 ${CUSTOMER_SHELL_WIDTH_CLASS} lg:[html[data-sidebar-visible]_&]:pl-56`}
      data-testid="customer-consent-sync-failed-host"
    >
      <p
        role="alert"
        className={`pointer-events-auto ${CUSTOMER_INLINE_NOTICE_WIDTH_CLASS} rounded-md border border-[var(--color-danger)] bg-[var(--color-surface)] px-3 py-2 text-sm text-[var(--color-danger)] shadow-md`}
        data-testid="customer-consent-sync-failed"
      >
        {t('consent.syncFailed')}
      </p>
    </div>
  );
}
